<div class="time-container" [ngClass]="getPulse()" >

  <span class="mr-3 text-center" > Tiempo restante disponible </span>

  <div class="time">
    <span> DÍAS </span>
    <span> {{ time.days }} </span>
  </div>


  <div class="time">
    <span> HRS </span>
    <span> {{ time.hours }} </span>
  </div>


  <div class="time">
    <span> MIN </span>
    <span> {{ time.minutes }} </span>
  </div>

  <div class="time">
    <span> SEG </span>
    <span> {{ time.seconds }} </span>
  </div>

</div>
